import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { TokenService, UserPlayer } from '@monorepo/auth'
import { SavedIlsService } from '../shared/services/savedIls.service'

/**
 * The IlsGuard ensures that only authenticated users who have access to a specific ILS can view its pages.
 * If an authenticated user tries to access an ILS that they do not have access to,
 * they will be redirected to the login page with the ILS ID saved, so they can log in again with a proper user.
 * If the user is not authenticated, they will also be redirected to the login page with the ILS ID saved, so they can login
 */

@Injectable({
  providedIn: 'root',
})
export class IlsGuard {
  private tokenService = inject(TokenService);
  private savedIlsService = inject(SavedIlsService);
  private router = inject(Router);

  constructor() {
    console.log('Ilsguard')
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const user = this.tokenService.getUser() as UserPlayer

    if (user) {
      const ilsId = this.getIlsIdFromUrl(state.url)
      if (ilsId === user.ilsId) {
        console.log('User is trying to access the ILS that they have access to.')
        return true
      } else {
        console.log('User is trying to access an ILS that they do not have access to - save the ILS, go to login.')
        this.saveIlsAndGoToLogin(ilsId)
        return false
      }
    }

    if (!user) {
      console.log('User does not exist - save the ILS, go to login.')
      const ilsId = route.params.ilsId || this.savedIlsService.previousUrl$.value
      this.saveIlsAndGoToLogin(ilsId)
      return false
    }
    return false
  }

  private getIlsIdFromUrl(url: string): string {
    const urlParts = url.split('/')
    const [ilsId] = urlParts[urlParts.length - 1].split('?')
    return ilsId
  }

  private saveIlsAndGoToLogin(ilsId: string) {
    console.log('User has been logged out. Going back to login page, with the ilsID saved.')
    this.tokenService.signOut()
    this.savedIlsService.saveUrl(ilsId)
    this.router.navigateByUrl('/login/' + ilsId)
  }
}
